import React from 'react'
import '../styles/Main.css'
import { useState } from 'react'
import { useEffect } from 'react'
import LiquidBlock from '../blocks/LiquidBlock'
import API from '../APIs/MainAPI'
import LiquidButton from '../blocks/LiquidButton'
import LiquidBlockTop from '../blocks/LiquidBlockTop'
import LiquidRoundButton from '../blocks/LiquidRoundButton'
import { useNavigate } from 'react-router-dom'
import LiquidSelector from '../blocks/LiquidSelector'
import ToggleSwitch from '../blocks/ToggleSwitch'

const Main = ({userData, setUserData}) => {
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [isOpenDesc, setIsOpenDesc] = useState(false)
  const [isOpenRegMemb, setIsOpenRegMemb] = useState(false)

  const [selectedGrade, setSelectedGrade] = useState(null)
  const [selectedGradeLett, setSelectedGradeLett] = useState(null)
  const [isGraduate, setIsGraduate] = useState(false)

  const [isAddMembDis, setIsAddMembDis] = useState(true)

  const [isSubm, setIsSubm] = useState(false)

  useEffect(() => {
  
  if (isGraduate) {
    // Если выпускник - кнопка разблокирована
    if(!selectedEvent.canGraduaited) {
      setIsAddMembDis(true)
      return
    }
    setIsAddMembDis(false);
  } else {
    // Если не выпускник - проверяем что выбран и класс и буква
    const shouldBeDisabled = !selectedGrade || !selectedGradeLett;
    setIsAddMembDis(shouldBeDisabled);
  }
}, [selectedGrade, selectedGradeLett, isGraduate]);

  const navigate = useNavigate()

  const gradesAv = (grades) => {
    if (grades.length <= 0) return null
    let avGrades = []

    grades.forEach(grade => {
      if(!avGrades.includes(grade.grade)){
        avGrades.push(grade.grade)
      }
    })
    return avGrades
  }

  useEffect(() => {
    setSelectedGradeLett(null)
  }, [selectedGrade])

  const gradesLetterAv = (grades) => {
    let filteredGrades = grades?.filter(grade => grade.grade == selectedGrade)
    if (filteredGrades.length <= 0) return null;
    
    let avGradesLett = [];
    
    filteredGrades.forEach(grade => {
        if (!avGradesLett.includes(grade.gradeLetter)) {
            avGradesLett.push(grade.gradeLetter);
        }
    });
    
    return avGradesLett;
};

  const addMember = () => {
    console.log(userData);
    
    let memberData = {
      usMongoID: userData._id,
      isGrad: isGraduate,
      gradeNum: selectedGrade,
      gradeLetter: selectedGradeLett
    }
    API.AddMember(selectedEvent, memberData).then((data) => {
      if(data.status == 200) {
        API.LoadEvents((data) => {
          setEvents(data.res.data)
        }).catch(e => console.error(e))

        setUserData(data.res.data.user)
        window.location.reload()
      }
    }).catch(e => console.error(e))
    
  }

  useEffect(() => {
    if(events.length == 0){
      API.LoadEvents().then((data) => {
        console.log(data.res);
        setEvents(data.res.data)
      })
    }
  }, [])

  return (
    <>
    {isOpenDesc ?
      <LiquidBlockTop>
        <LiquidRoundButton onClick={() => {
          setSelectedEvent(null)
          setIsOpenDesc(false)
          }}>←</LiquidRoundButton>
        <div className="selEventBlock">
          <h1 className='selEventName'>{selectedEvent?.name}</h1>
          <p className='eventDescr'>{selectedEvent?.description}</p>
          <h4 className='subEventText'>Место проведения:</h4>
          <h3>{selectedEvent?.place}</h3>
          <h4 className='subEventText'>Дата:</h4>
          <h3>{selectedEvent?.date}</h3>
          <h4 className='subEventText'>Время:</h4>
          <h3>{selectedEvent?.time}</h3>
          <h4 className='subEventText'>Кол-во участников:</h4>
          <h3>{selectedEvent?.members?.length}/{selectedEvent?.memberCount}</h3>
          <h4 className='subEventText'>Классы:</h4>
          <div className="selected-grades-list">
              {selectedEvent?.grades?.length > 0 ? (
                selectedEvent?.grades?.map((grade, index) => (
                  <span key={index} className="selected-grade-tag">
                    {grade.grade}{grade.gradeLetter}
                  </span>
                ))
              ) : (
                <span className="no-grades">Нет выбранных классов</span>
              )}
            </div>
        </div>
        {
          userData?.events?.includes(selectedEvent?._id) ? 
          <LiquidButton onClick={() => navigate('/tickets')}>К билету</LiquidButton> : 
          selectedEvent?.status == 'regClosed' ?
          <LiquidButton disabled>Регистрация закрыта</LiquidButton> 
          : selectedEvent?.members?.length >= selectedEvent?.memberCount ? 
          <LiquidButton disabled>Места закончились</LiquidButton> 
          : selectedEvent?.status == 'regOpen' ? 
          <LiquidButton onClick={() => {
            setIsOpenRegMemb(true)
            setIsOpenDesc(false)
          }}>Участвовать</LiquidButton> : null
        }
      </LiquidBlockTop>
     : null}
     {isOpenRegMemb ? <LiquidBlockTop>
      <LiquidRoundButton onClick={() => {
          setIsOpenRegMemb(false)
          setIsOpenDesc(true)
        }}>←</LiquidRoundButton>
        <div className="selEventBlock">
          <h1 className='selEventName'>Запись</h1>
          <input type="text" className='regInput' value={userData.firstName} disabled/>
          <input type="text" className='regInput' value={userData.secondName} disabled/>
          <input type="text" className='regInput' value={userData.thirdName} disabled/>
          {selectedEvent?.grades?.length > 0 ? (<>
            <h4 className='subEventText'>Класс:</h4>
            <ToggleSwitch 
              label="Выпускник:"
              checked={isGraduate}
              onChange={(value) => setIsGraduate(value)}
            />
            {!isGraduate ? <div className="classSelector">
              <LiquidSelector
                id="grade-selector"
                name="selectGrade"
                options={gradesAv(selectedEvent?.grades)}
                value={selectedGrade}
                onChange={setSelectedGrade}
                className="form-control"
                placeholder="Класс"
                required={true}
              />
              <LiquidSelector
                id="gradeLetter-selector"
                name="selectLetter"
                options={gradesLetterAv(selectedEvent?.grades)}
                value={selectedGradeLett}
                onChange={setSelectedGradeLett}
                className="form-control"
                placeholder="Буква"
                required={true}
                disabled={selectedGrade == null}
              />
            </div> : null}
            
          </>) : null}
          <div className="addButtonCont">
            {!isSubm ? <LiquidButton disabled={isAddMembDis || isSubm} onClick={() => {
                setIsSubm(true)
                addMember()
              }}>Запись</LiquidButton> : null}
            
          </div>
        </div>
     </LiquidBlockTop> : null}
    <section className='mainSection'>
      <h2 className='eventsTxt'>Мероприятия</h2>
      <div className="events">
        {events?.map(event => {
          if(event?.status != 'eventClosed') return (
            <LiquidBlock key={event?._id}>
              <div className="textEventData">
                <h2>{event?.name}</h2>
                <p>{event?.date} | {event?.time} | {event?.members?.length}/{event?.memberCount}</p>
                {userData?.events?.includes(event?._id) ? <h3 className='eventOpen'>Вы участвуете</h3> :
                event?.status == "regClosed" ? <h3 className='eventClosed'>Закрыто</h3> : event?.status == "regOpen" ? <h3 className='eventOpen'>Открыто</h3> : <h3 className='eventEnded'>Окончено</h3>}
              </div>

              <LiquidButton onClick={() => {
                setSelectedEvent(event)
                setIsOpenDesc(true)
                }}>Подробнее</LiquidButton>
            </LiquidBlock>
          )
        })}
      </div>
    </section>
    </>
  )
}

export default Main